<script setup lang="ts">
import FullImage from '~/components/block/FullImage.vue';
import ImageLogos from '~/components/block/ImageLogos.vue';
import Hero from '~/components/block/Hero.vue';
import RichText from '~/components/block/RichText.vue';
import Gallery from '~/components/block/Gallery.vue';
import Pricing from '~/components/block/Pricing.vue';
import Posts from '~/components/block/Posts.vue';
import Form from '~/components/block/FormBlock.vue';
import Inscriptions from '~/components/block/Inscriptions.vue';
// import ButtonGroup from '~/components/base/ButtonGroup.vue';

interface BaseBlockProps {
  block: {
    collection: string;
    item: any;
    id: string;
    background_color?: string | null;
    custom_css?: string | null;
  };
}

const props = defineProps<BaseBlockProps>();
const blockRef = ref<HTMLElement | null>(null);

const components: Record<string, any> = {
  block_full_image: FullImage,
  block_image_logo: ImageLogos,
  block_hero: Hero,
  block_richtext: RichText,
  block_gallery: Gallery,
  block_pricing: Pricing,
  block_posts: Posts,
  block_form: Form,
  block_inscriptions: Inscriptions,
  // block_button_group: ButtonGroup,
};

const Component = computed(() => components[props.block.collection] || null);
// block item plus collection id
const componentData = computed(() => ({
  ...props.block.item,
  block_id: props.block.id,
}));

const backgroundColor = props.block.background_color;
if (backgroundColor) {
  blockRef.value?.style.setProperty('--bg', backgroundColor);
} else {
  blockRef.value?.style.removeProperty('--bg');
}
// computed value to convert tagline to id (with dashes and lowercase, no special chars, fallback to headline if no tagline)
const idClean = computed(() => {
  const text = componentData.value.tagline || componentData.value.headline || '';
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
});
</script>

<template>
  <div ref="blockRef" class="relative pt-16" :style="props.block.custom_css" :id="idClean">
    <component :is="Component" v-if="Component" :id="`block-${block.id}`" :data="componentData" />
  </div>
</template>
